import React, { useMemo } from 'react';
import styles from './Heading.module.scss';
import { TICKET_STATUSES } from '../../../../constants/enums';

const Heading = ({ statusId, primary, secondary, children, ...props }) => {
    const statusName = useMemo(() => {
        let name = '';
        switch (statusId) {
            case TICKET_STATUSES.open:
                name = 'open';
                break;
            case TICKET_STATUSES.cancelled:
                name = 'cancelled';
                break;
            case TICKET_STATUSES.won:
                name = 'won';
                break;
            case TICKET_STATUSES.lost:
                name = 'lost';
                break;
            case TICKET_STATUSES.draw:
                name = 'draw';
                break;
            case TICKET_STATUSES.void:
                name = 'void';
                break;
            case TICKET_STATUSES.refunded:
                name = 'refunded';
                break;
            case TICKET_STATUSES.paid:
                name = 'paid';
                break;
            default:
                break;
        }
        return name;
    }, [statusId]);

    return (
        <div className={`${styles.headingWrapper} ${styles[statusName]}`}>
            <div className={styles.heading} {...props}>
                <h4 className={styles.primary}>{primary}</h4>
                <p className={styles.secondary}>{secondary}</p>
            </div>
            {children}
        </div>
    );
};

export default Heading;
